

export class LoginDto implements ILoginDto {
    userName!: string | undefined;
    password!: string | undefined;
    fcmToken!: string | undefined;

    constructor(data?: ILoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.fcmToken = _data["fcmToken"];
        }
    }

    static fromJS(data: any): LoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["fcmToken"] = this.fcmToken;
        return data; 
    }
}

export interface ILoginDto {
    userName: string | undefined;
    password: string | undefined;
    fcmToken: string | undefined;
}

